import { render, staticRenderFns } from "./ItemOptionSelector.vue?vue&type=template&id=2f03e5e1&scoped=true&"
import script from "./ItemOptionSelector.vue?vue&type=script&lang=ts&"
export * from "./ItemOptionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ItemOptionSelector.vue?vue&type=style&index=0&id=2f03e5e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f03e5e1",
  null
  
)

export default component.exports